import React, { Fragment } from "react";
import { Link } from 'react-router-dom';


const Description = ()=> {

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Download and play the Dragon Hit game </h5>
        <p> End up among the first 5 players in a daily tournament. You will be rewarded up to <strong>1.000</strong> points for your performance. </p>
      </div>
      <Link className="btn action btn-primary" to={"/tournament"}> Play</Link>
    </Fragment>
  );
};

export default Description;
